var $bc0cb3357c6a211c$exports = {};
$bc0cb3357c6a211c$exports = {
    "help": `\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}`,
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`
};


export {$bc0cb3357c6a211c$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
